import { Pressable, View } from 'react-native';
import { createBox } from '../../theme';
export const Box = createBox(View);
export const PressableBox = createBox(Pressable);
